export const UKRAINE = 'UA'
export const UNITED_STATES = 'US'
export const ARGENTINA = 'AR'
export const BRAZIL = 'BR'

export const BLOCKED_COUNTRY_CODES: readonly string[] = [
  'AF', // Afghanistan
  'BY', // Belarus
  'CD', // Congo, the Democratic Republic
  'CU', // Cuba
  'KP', // Democratic People's Republic of Korea (North Korea)
  'HT', // Haiti
  'IR', // Iran, Islamic Republic of
  'IQ', // Iraq
  'LB', // Lebanon
  'LY', // Libya
  'MM', // Myanmar
  'RU', // Russian Federation
  'SO', // Somalia
  'SS', // South Sudan
  'SD', // Sudan
]
